<template>
    <ui-PanelOverlay panel="config" :id="`componet_${_uid}`" :show="show" :loading="loading">
        <template v-slot:menuBar>
            <PanelMixinBack></PanelMixinBack>
        </template>
        <template v-slot:body>
            <ui-RichMenu :name="$dicc.configConfigPanel.title" :navigation="true">
                <template v-slot:options>
                    <FormMixinInput :label="$dicc.user.name" type="text" property="name"></FormMixinInput>
                    <FormMixinInput :label="$dicc.user.phone" type="tel" property="phone"></FormMixinInput>
                    <FormMixinInput
                        :label="$dicc.user.lang"
                        type="select"
                        property="lang"
                        :options="$fns.orderObjectByValue($config.AVAILABLE_LANGS)"
                    ></FormMixinInput>
                    <FormMixinInput
                        :label="$dicc.configConfigPanel.selectTemp"
                        type="select"
                        property="temp"
                        :options="$dicc.typeMetrics"
                    ></FormMixinInput>
                    <FormMixinInput
                        :label="$dicc.configConfigPanel.gdprNotifications"
                        type="checkbox"
                        property="gdpr_notifications"
                    ></FormMixinInput>
                    <label v-if="false">{{ msgError }}</label>
                    <div class="richMenu__actions">
                        <a class="btn btn--simple" @click="doUpdateProfile">{{ $dicc.confirm }}</a>
                    </div>
                </template>
            </ui-RichMenu>
        </template>
    </ui-PanelOverlay>
</template>

<script>
    // :class="{ modeHeat: device.status.m != '0' }" class="fulldevice"
    import { PanelMixin } from '../mixins/PanelMixin';
    import { FormMixin } from '../mixins/FormMixin';

    export default {
        name: 'ConfigConfigPanel',
        mixins: [PanelMixin, FormMixin],
        data: function() {
            return {
                type: 'config',
            };
        },
        methods: {
            init() {
                if (this.show) this.getUser();
                else this.fillModel(this.$session.getUser());
            },

            fillModel(objUser) {
                this.$set(this, 'model', {
                    name: objUser.name,
                    phone: objUser.phone,
                    gdpr_notifications: objUser.gdpr_notifications,
                    gdpr_emailing: true, //TODO: quitar
                    lang: objUser.lang,
                    temp: objUser.temp,
                });
            },

            getUser() {
                this.loading++;

                this.$api.getUser(
                    (data) => {
                        this.$session.setUpdateUser(data.entity);
                        this.fillModel(this.$session.getUser());
                    },
                    null,
                    () => this.loading--
                );
            },

            doUpdateProfile: function() {
                this.loading++;
                this.resetErrors();

                this.$api.updateProfile(
                    this.model,
                    (data) => {
                        this.$session.setUpdateUser(data.entity);
                        this.$toast({
                            message: this.$dicc.configConfigPanel.updated,
                            container: `#componet_${this._uid}`,
                            type: 'is-success',
                        });
                        //this.$router.push({ name: 'Validate' });
                    },
                    (error) => this.showError(error),
                    () => this.loading--
                );
            },
        },
        watch: {
            show: {
                immediate: true,
                handler() {
                    this.init();
                },
            },
            'model.lang': {
                immediate: true,
                handler(val) {
                    this.$changeLanguage(val);
                },
            },
            'model.temp': {
                immediate: true,
                handler(val) {
                    this.$changeMetric(val);
                },
            },
        },
    };
</script>
